import { render, staticRenderFns } from "./DeliveryChart.vue?vue&type=template&id=52299401&scoped=true"
import script from "./DeliveryChart.vue?vue&type=script&lang=js"
export * from "./DeliveryChart.vue?vue&type=script&lang=js"
import style0 from "./DeliveryChart.vue?vue&type=style&index=0&id=52299401&prod&lang=scss"
import style1 from "./DeliveryChart.vue?vue&type=style&index=1&id=52299401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52299401",
  null
  
)

export default component.exports